'use client';
import React, { PropsWithChildren } from 'react';
import { useFullMenu } from './use-full-menu';
import { cn } from '@lib/utils';

const FullMenuWrapper = ({ children }: PropsWithChildren) => {
  const { isOpen } = useFullMenu();

  return (
    <div
      className={cn(
        'absolute -top-0 bottom-0 left-0 right-0 z-[22] h-screen w-full bg-[#040435]',
        isOpen ? 'block' : 'hidden',
      )}
    >
      <div className="relative m-auto flex h-screen w-full max-w-[1420px] flex-col justify-between px-[50px] py-[35px]">
        {children}
      </div>
    </div>
  );
};

export default FullMenuWrapper;
